import axios from "axios";

const getv2AppConfigSchema = async (platform) => {
    const response = await axios.get(`/api/customizations/v2/app-config-schema/platform/${platform}`);
    // console.log("APi config response ", response.data)
    return response.data;
}

const getSavedConfig = async (projectId) => {
    let data = { projectId: projectId }
    const response = await axios.post('/api/customizations/v2/saved-config', data);
    return response.data;
}

const storeConfig = async (projectId, config_type, config) => {
    let data = { projectId: projectId, groupName: config_type, formdata: config }
    const response = await axios.post('/api/customizations/v2/store-config', data);
    return response.data;
}

const uploadImage = async (projectId, fieldId, imageData, contentType) => {
    let data = { projectId: projectId, fieldId: fieldId, imageData: imageData, contentType: contentType }
    const response = await axios.post('/api/customizations/v2/upload-image', data);
    return response.data;
}

const getAppSavedConfig = async (projectId, version,platform) => {
    let data = { projectId: projectId, version: version , platform:platform}
    // console.log("Data:",data);
    const response = await axios.post('/api/customizations/v2/app-saved-config', data);
    return response.data;
}

const storeAppConfig = async (projectId, version, config_type, config,platform) => {
    let data = { projectId: projectId, version: version, groupName: config_type, formdata: config,platform:platform }
    const response = await axios.post('/api/customizations/v2/store-app-config', data);
    return response.data;
}

const getAppV2ConfigVersions = async (projectId,platform) => {
    let formdata = {
        projectId,
        platform
    }
    const response = await axios.post('/api/customizations/v2/app-config-versions', formdata);
    return response.data;
}

const createAppConfig = async (formdata) => {
    const response = await axios.post('/api/customizations/v2/create-app-config', formdata);
    return response.data;
}
const publishAppConfig = async (projectId, version,platform) => {
    const response = await axios.post('/api/customizations/v2/publish-app-config', { projectId, version,platform })
    return response.data;
}
const deactivateAppConfig = async (projectId, version) => {
    const response = await axios.post('/api/customizations/v2/deactivate-app-config', { projectId, version })
    return response.data;
}
const activateAppConfig = async (projectId, version) => {
    const response = await axios.post('/api/customizations/v2/activate-app-config', { projectId, version })
    return response.data;
}
const getV2Resources = async (payload) => { // payload can be { config_id } or { projectId, version, config }
    const response = await axios.post('/api/customizations/v2/get-resources', payload);
    return response.data;
};
const getV2AppTemplatesList = async (platform) => { 
    const response = await axios.get(`/api/customizations/v2/app-templates-list?platform=${platform}`);
    return response.data;
};



export default {

    getSavedConfig,
    storeConfig,
    uploadImage,
    getAppSavedConfig,
    storeAppConfig,
    getAppV2ConfigVersions,
    createAppConfig,
    publishAppConfig,
    deactivateAppConfig,
    activateAppConfig,
    getv2AppConfigSchema,
    getV2Resources,
    getV2AppTemplatesList
}